import script from "./kucun.vue?vue&type=script&setup=true&lang=js"
export * from "./kucun.vue?vue&type=script&setup=true&lang=js"

import "./kucun.vue?vue&type=style&index=0&id=b2a890b4&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2a890b4"]])

export default __exports__